module.exports = __webpack_public_path__ + "img/nas-download-icon2.152b0fdd.png";